/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import DropDownComponent from './Dropdown';
import DateRange from './DateRange';
import { dataService } from '../../../../services/data.services';
import { GetBranchId } from '../../../../CommonMethods/GetBranchId';
import { formatAdjustedDate } from '../../../../CommonMethods/formatDate';

const DateRangeForDropDown = ({
    handleSelectObject, setSelectedDates,  
    FilterCheckbox ,dateError, selectedDates,
    setIsFilterOpen,setSearchParams, setFilterCheckBox,
    currentFinacialYear,academicYears,
    finacialYear, filterCount,
    selectedName,setSelectedName,
    searchParams,setEndDate,
    setSelectedDateRange,setStartDate,calculateEndDate,
    selectedDateRange,setdateError,
    handleCheck, dateErrorMsg}) =>{

    const dateRangeDropdownOptions = [{ name: 'Financial Year' }, { name: 'Academic Year' }, { name: 'Custom' }];
    const [isMainDropdownOpen, setIsMainDropdownOpen] = useState(false);
    const [didSubDropdownChange, setDidSubDropdownChange] = useState(false)
  
    /**
     * The function `handleNameSelection` updates the selected name, start date, end date, and search
     * parameters based on the provided id, name, start date, and end date.
     */
    const handleNameSelection = (id, name, startDate, endDate) => {
        setDidSubDropdownChange(true)
        setSelectedName(name);
        endDate = id === "FY" ? calculateEndDate(endDate) : endDate;
        const formattedDateStartDate = new Date(startDate).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        });
        const formattedDateEndDate = new Date(endDate).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            timeZone: 'UTC' 
        });
        
        handleSelectObject('start_date',formattedDateStartDate); 
        handleSelectObject('end_date', formattedDateEndDate);
    }

    /**
     * The function `handleOnchangeInput` updates the selected date range based on the input item's name.
     */
    const handleOnchangeInput = (id, item, index) => {
        if(id === 'Date Range'){
            if(item.name === 'Custom'){
                setSelectedDateRange(item.name)
                if(searchParams.get('dropname') !== 'Custom' || searchParams.get('main') !== 'Custom'){
                    setFilterCheckBox((prv)=>({
                        ...prv,
                        start_date : searchParams.get('start_date') === null ? null : searchParams.get('start_date'),
                        end_date :  searchParams.get('end_date') === null ? null : searchParams.get('end_date')
                    }))
                }
                setSelectedName('Custom')
            } else {
                setSelectedDateRange(item.name)
            }
        }
    }

    return (
        <div> 
            {/* Main Dropdown */}
            <DropDownComponent
                dropDownName={"Date Range"}
                id={"Date Range"}
                test_id={"Date Range"}
                divClassName={`slct-inpt-fld-div`}
                value={selectedDateRange}
                placeHolder={"Date Range"}
                buttonDisabled={false}
                buttonClassName={`slct-inpt-fld transition duration-150 ease-in-out error_border more-lines`}
                options={dateRangeDropdownOptions}
                handleOnchangeInput={handleOnchangeInput}
                tooltip={true}
                didSubDropdownChange={didSubDropdownChange}
                searchParams={searchParams}
                setisOpen={setIsMainDropdownOpen}
                isOpen={isMainDropdownOpen}
            />
            {/* FY dropdown option */}
            {!isMainDropdownOpen && selectedDateRange === 'Financial Year' && <div className={`slct_drp_dwn_optn-div scroll-bar`}>
                <ul>
                    {/* Render the names in finacialYear and handle selection */}
                    {finacialYear?.map((item, index) => (
                        <li className={`slct_drp_dwn_optn ${selectedName === item.name ? 'selected' : ''}`} 
                            title={`${item.name} (${formatAdjustedDate(item.start_date)} - ${formatAdjustedDate(item.end_date)}) (${item?.status?.charAt(0)?.toUpperCase() + item?.status?.slice(1)})`}
                            key={index} onClick={() => handleNameSelection('FY', item.name, item.start_date, item.end_date)}>
                            {`${item.name} (${item?.status?.charAt(0)?.toUpperCase() + item?.status?.slice(1)})`}
                        </li>
                    ))}
                </ul>
            </div>}
            {/* AY dropdown option */}
            {!isMainDropdownOpen && selectedDateRange === 'Academic Year' && <div className={`slct_drp_dwn_optn-div scroll-bar`}>
                <ul>
                    {/* Render the names in academicYears and handle selection */}
                    {academicYears.length !== 0 ? academicYears?.map((item, index) => (
                        <li className={`slct_drp_dwn_optn ${selectedName === item.name ? 'selected' : ''}`} 
                            title={`${item.name} (${formatAdjustedDate(item.start_date)} - ${formatAdjustedDate(item.end_date)}) (${item?.status?.charAt(0)?.toUpperCase() + item?.status?.slice(1)})`}
                            key={index} onClick={() => handleNameSelection('AY', item.name, item.start_date, item.end_date)}>
                            {`${item.name} (${item?.status?.charAt(0)?.toUpperCase() + item?.status?.slice(1)})`}
                        </li>
                    )) : <p className='flex justify-center items-center break-words'>No Academic Years found.</p>}
                </ul>
            </div>}
            {/* Custom dropdown option */}
            {!isMainDropdownOpen && selectedDateRange === 'Custom' && <div className='ml-1'><DateRange 
                setSelectedDates={setSelectedDates} 
                dateError={dateError} 
                dateErrorMsg={dateErrorMsg}
                setdateError={setdateError} 
                handleCheck={handleCheck} 
                didSubDropdownChange={didSubDropdownChange}
                selectedDates={selectedDates}
                searchParams={searchParams}
                handleSelectObject={handleSelectObject} 
                setIsFilterOpen={setIsFilterOpen} 
                isDateRangeSelected={selectedDateRange !== 'Custom'}
                FilterCheckbox={FilterCheckbox}/></div>}
        </div>
    )
}

export default DateRangeForDropDown